/*
 * @Date: 2023-11-28 18:30:45
 * @LastEditors: shizheng 64840669+code-cola-js@users.noreply.github.com
 * @LastEditTime: 2023-12-14 09:41:17
 * @FilePath: \hisea-ssr\src\components\FilterModal\CurrentFilters\currentFilters.js
 */
import { useStyle } from '@/classify';
import Button from '@/components/Button';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Minus, Plus } from 'react-feather';
import { useIntl } from 'react-intl';
import CurrentFilter from './currentFilter';
import defaultClasses from './currentFilters.module.css';
const CurrentFilters = props => {
  const { isMobile } = useIsMobile();
  const { filterApi, filterState, onRemove, clearAll, isResearch = true, isOpenSeeMore = true } = props;
  const { removeItem } = filterApi;
  const classes = useStyle(defaultClasses, props.classes);
  const { formatMessage } = useIntl();
  const [showSeeMore, setShowSeeMore] = useState(false);
  const [toggleMore, setToggleMore] = useState(false);
  const containerRef = useRef(null);
  const wrapperRef = useRef(null);
  const mobileContainerRef = useRef(null);

  // create elements and params at the same time for efficiency
  const filterElements = useMemo(() => {
    const elements = [];

    const filterStateArray = Array.from(filterState);
    // 按这个顺序排序
    const sortOrder = ['lw_product_usage', 'lw_size', 'lw_color', 'lw_material', 'price'];

    const sortedArray = filterStateArray.sort((a, b) => {
      return sortOrder.indexOf(a[0]) - sortOrder.indexOf(b[0]);
    });

    const sortedMap = new Map(sortedArray);

    for (const [group, items] of sortedMap) {
      for (const item of items) {
        const { title, value } = item || {};
        const key = `${group}::${title}_${value}`;

        elements.push(
          <li
            key={key}
            className={classes.item}
          >
            <CurrentFilter
              group={group}
              item={item}
              removeItem={removeItem}
              onRemove={onRemove}
              isResearch={isResearch}
            />
          </li>,
        );
      }
    }

    if (elements.length === 0) {
      return null;
    }

    if (isMobile) {
      return (
        <div
          ref={mobileContainerRef}
          className={cn(
            classes.filterElementsContainer,
            toggleMore || !isOpenSeeMore ? 'h-auto' : 'h-[60px] overflow-hidden',
          )}
        >
          {elements}
          <div
            className={cn(
              'absolute bottom-[10px] left-0 flex w-full items-center justify-between bg-white',
              classes.resetFiltersWrapper,
            )}
          >
            {showSeeMore && isOpenSeeMore && (
              <Button
                className={cn(
                  'pd-0 flex h-[30px] w-[118px] items-center justify-center rounded-[15px] bg-[#E0E0E0] font-roboto-regular text-[16px] font-normal leading-[30px]',
                )}
                onClick={() => {
                  setToggleMore(prev => !prev);
                }}
              >
                {toggleMore ? <Minus size={16} /> : <Plus size={16} />}
                See More
              </Button>
            )}
            <Button
              className={cn('ml-auto h-[30px]')}
              onClick={() => clearAll()} // 确保作为函数调用
            >
              <span className='font-roboto-regular text-[18px] font-normal leading-[30px] underline'>Clear All</span>
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className={cn('relative w-full pr-[120px]')}>
        <div
          className={cn(classes.filterElementsContainer, toggleMore ? 'h-auto' : 'h-[30px] overflow-hidden')}
          ref={containerRef}
        >
          <div
            className='inline-block'
            ref={wrapperRef}
          >
            {elements}
          </div>
        </div>
        {showSeeMore && (
          <Button
            className={cn(
              'pd-0 absolute bottom-0 right-0 flex h-[30px] w-[118px] items-center justify-center rounded-[15px] border-none bg-[#E0E0E0] font-roboto-regular text-[16px] font-normal leading-[30px]',
            )}
            onClick={() => {
              setToggleMore(prev => !prev);
            }}
          >
            {toggleMore ? <Minus size={16} /> : <Plus size={16} />}
            See More
          </Button>
        )}
      </div>
    );
  }, [classes.item, filterState, removeItem, onRemove, isMobile, showSeeMore, toggleMore, clearAll]);

  const currentFiltersAriaLabel = formatMessage({
    id: 'filterModal.currentFilters.ariaLabel',
    defaultMessage: 'Current Filters',
  });

  useEffect(() => {
    if (isMobile) {
      if (mobileContainerRef.current) {
        const isOverflowing = mobileContainerRef.current.scrollHeight > 60;
        if (isOverflowing) {
          setShowSeeMore(true);
        } else {
          setShowSeeMore(false);
        }
      }
    } else {
      if (containerRef.current && wrapperRef.current) {
        console.log('containerRef', wrapperRef.current.scrollWidth, containerRef.current.clientWidth);
        const isOverflowing = wrapperRef.current.scrollWidth + 10 > containerRef.current.clientWidth;

        if (isOverflowing) {
          setShowSeeMore(true);
        } else {
          setShowSeeMore(false);
        }
      }
    }
  }, [filterElements]);

  return (
    <ul
      className={classes.root}
      aria-label={currentFiltersAriaLabel}
    >
      {/* {filterState.size !== 0 && (
        <span className={classes.resetFiltersTips}>Reset Filters</span>
      )} */}
      {filterElements}
    </ul>
  );
};

export default CurrentFilters;
